import { useContext } from "react";
import { Navigate } from "react-router-dom";
import { SubscriptionContext } from "./SubscriptionContext";

const SubscriptionRoute = ({ children, role = "admin" }) => {
  const { subscribed, loading } = useContext(SubscriptionContext);

  if (loading) return <div>Cargando suscripción...</div>;
  if (subscribed === false) {
    const redirectPath = role === "admin" ? "/admin/subscribe" : "/unauthorized";
    return <Navigate to={redirectPath} />;
  }

  return children;
};

export default SubscriptionRoute;
